import { render, staticRenderFns } from "./CorrectTextMatchPicker.vue?vue&type=template&id=40915014&scoped=true&"
import script from "./CorrectTextMatchPicker.vue?vue&type=script&lang=ts&"
export * from "./CorrectTextMatchPicker.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectTextMatchPicker.vue?vue&type=style&index=0&id=40915014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40915014",
  null
  
)

export default component.exports